<template>
    <div class="page">
        <mt-header title="发现">
            <mt-button icon="back"   slot="left" @click="closeqShop">返回</mt-button> 
        </mt-header>
        <div class="page-content" v-if="!hidddenQuery">
            <mt-navbar class="page-part" v-model="selected">
                <mt-tab-item id="1">预约外卖查询</mt-tab-item>
                <mt-tab-item id="2">餐厅查询</mt-tab-item>
            </mt-navbar>
            <mt-tab-container v-model="selected">
                <mt-tab-container-item id="1">
                    <Takeout-Query @selectAddress="selectAddress" @selectTime="selectTime"></Takeout-Query>
                </mt-tab-container-item>
                <mt-tab-container-item id="2">
                    <Meal-Query></Meal-Query>
                </mt-tab-container-item>
            </mt-tab-container> 
        </div>                       
        <popup-full-picker
            v-if="results && results.length"
            :popupTypeText="popupTypeText"
            :showPicker="showPicker"
            :results="results"
            @popupHandle="popupHandle"
            @submitHandle="submitHandle"
        />          
    </div>
</template>
<script>
    import { mapGetters, mapMutations, mapActions } from 'vuex'
    import TakeoutQuery from "@/components/takeoutQuery"
    import MealQuery from "@/components/mealQuery"
    import PopupFullPicker from '@/components/popup-full-picker'
    import selectInfo from '@/components/selectInfo.js'
    import closeWebview from '@/components/closeWebview'
    export default {
        mixins: [selectInfo, closeWebview],
        data() {
            return {
                selected:"1",
                showPicker: false,
            }
        },
        computed: {
            ...mapGetters([
                'tab',
                'TakeoutCityDictVal',
                'hidddenQuery'
            ])
        },
        created() {
            let selected = this.iStorage.get('mealQueryType') || '1'
            this.selected = selected
            this.iStorage.remove('mealQueryType')
        },      
        methods: {
            closeqShop() {
                  this.closeWebview()  
            }
        },
        components: {
            TakeoutQuery,
            MealQuery,
            PopupFullPicker                       
        }
    }   
</script>
<style lang="scss" scoped>
    .page-part {
        margin-bottom: 15px;
    }    
</style>    


// WEBPACK FOOTER //
// src/views/defaultIndex.vue